import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Seo } from '../components/Seo';

const NotFound = () => (
  <div className="min-h-screen bg-[#1F1A17] flex items-center justify-center px-4">
    <Seo title="Page Not Found" description="The page you were looking for could not be found." path="/404" />
    <div className="text-center max-w-lg">
      <p className="text-[#C5A880] text-7xl md:text-8xl font-bold mb-4">404</p>
      <h1 className="text-2xl md:text-3xl font-bold text-[#EADBC8] mb-4">This page has wandered off</h1>
      <p className="text-[#EADBC8]/60 mb-8">
        The page you’re looking for doesn’t exist or may have moved. Let’s get you back to something beautiful.
      </p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <Link to="/"><Button className="bg-[#C5A880] hover:bg-[#D4BC95] text-[#1F1A17] font-semibold px-8 py-6">Back to Home</Button></Link>
        <Link to="/glam-booth"><Button variant="outline" className="border-2 border-[#C5A880] text-[#C5A880] hover:bg-[#C5A880] hover:text-[#1F1A17] font-semibold px-8 py-6">View the Glam Booth</Button></Link>
      </div>
    </div>
  </div>
);

export default NotFound;
